import gql from "graphql-tag"

export default gql`
  fragment IngestionSourceFragment on IngestionSource {
    id
    name
    providerId
    destinationProviderId
    rootPath
    rootFolderId
    enabled
    autoImport
    scanIntervalSeconds
    stabilitySeconds
    extensions
    lastScanAt
    lastScanError
  }
`
